import { Card, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// ชื่อประเภทรถและชนิดน้ำมันเป็นชุดค่าคงที่ปิดตายตัว จึงแปลได้ฝั่ง frontend โดยไม่ต้องรอ backend
const VEHICLE_TYPE_KEY = {
    motorcy: 'vehicle_motorcycle',
    car: 'vehicle_car',
    van: 'vehicle_van',
};
const FUEL_NAME_KEY = {
    'แก๊สโซฮอล์ 91': 'fuel_gasohol_91',
    'แก๊สโซฮอล์ 95': 'fuel_gasohol_95',
    'แก๊สโซฮอล์ E20': 'fuel_gasohol_e20',
    'ดีเซล': 'fuel_diesel',
    'ดีเซล B7': 'fuel_diesel_b7',
    'ดีเซล Premium': 'fuel_diesel_premium',
};

const TravelPlanner = ({ data, nameMap = {} }) => {
    const { t, i18n } = useTranslation();
    const translateName = (name) => (i18n.language === 'en' ? (nameMap[name] || name) : name);

    // ฟังก์ชันคำนวณปริมาณน้ำมัน
    const calculateOilUsage = (distance, efficiency) => {
        if (efficiency === 0) return 0;
        return (distance / efficiency) * 1000; // in ml
    };

    // ฟังก์ชันคำนวณค่าใช้จ่าย
    const calculatePriceBath = (oilUsage, pricePerLiter) => {
        return (oilUsage / 1000) * pricePerLiter;
    };

    // ฟังก์ชันคำนวณ Carbon Footprint (ปรับปรุงให้เหมือนในภาพ)
    const calculateCO2E = (oilUsageInLiter) => {
        // สมมติว่าน้ำมัน 1 ลิตร = 2.4 kg CO2e โดยประมาณ
        const co2eFactor = 2.4;
        return (oilUsageInLiter * co2eFactor);
    };

    return (
        // ... (ส่วนบนของ component เหมือนเดิม)
        <Grid item xs={12}>
            {/* <Card sx={{ p: 2, borderRadius: 4, boxShadow: 3 }}> */}
            <Typography component="h2" align="left" gutterBottom>
                {t('oil_price_note')}
            </Typography>
            <TableContainer component={Paper} sx={{ mt: 2, border: '1px solid', borderColor: 'grey.300' }}>

                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300', textAlign: 'center' }}>{t('table_route')}</TableCell>
                            <TableCell rowSpan={2} sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300', textAlign: 'center' }}>{t('table_distance')}</TableCell>
                            <TableCell colSpan={12} sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300', textAlign: 'center' }}>{t('table_carbon_cost')}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300' }}>{t('table_vehicle')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300' }}>{t('table_fuel')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300' }}>{t('table_price_per_liter')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300' }}>{t('table_fuel_used')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300' }}>{t('table_carbon_amount')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', border: '1px solid', borderColor: 'grey.300' }}>{t('table_amount_baht')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((route, routeIndex) => {
                            // console.log("rr", route);
                            return route?.vehicles?.map((vehicle, vehicleIndex) => {
                                const vehicleRows = vehicle.fuelTypes.length;
                                const oilUsageInMl = calculateOilUsage(route.distance, vehicle.efficiency);
                                const oilUsageInLiter = oilUsageInMl / 1000;
                                // console.log("vehicleRows", vehicleRows);
                                // console.log("oilUsageInMl", oilUsageInMl);
                                // console.log("oilUsageInLiter", oilUsageInLiter);
                                // console.log("vehicle", vehicle);

                                return vehicle?.fuelTypes?.map((fuelType, fuelIndex) => {
                                    // console.log("fuelType", fuelType);
                                    return (
                                        <TableRow key={`${routeIndex}-${vehicleIndex}-${fuelIndex}`}>

                                            {/* ช่อง "เส้นทาง" */}
                                            {vehicleIndex === 0 && fuelIndex === 0 && (
                                                <TableCell
                                                    rowSpan={route?.vehicles?.reduce((sum, v) => sum + v.fuelTypes?.length, 0)}
                                                    sx={{ border: '1px solid rgba(0,0,0,0.2)' }}
                                                >
                                                    {translateName(route?.origin)} - {translateName(route?.destination)}
                                                </TableCell>
                                            )}

                                            {/* ช่อง "ระยะทาง" */}
                                            {fuelIndex === 0 && (
                                                <TableCell
                                                    rowSpan={vehicleRows}
                                                    sx={{ border: '1px solid rgba(0,0,0,0.2)' }}
                                                >
                                                    {route?.distance.toFixed(2)}
                                                </TableCell>
                                            )}

                                            {/* ช่อง "พาหนะ" */}
                                            {fuelIndex === 0 && (
                                                <TableCell
                                                    rowSpan={vehicleRows}
                                                    sx={{ border: '1px solid rgba(0,0,0,0.2)' }}
                                                >
                                                    {VEHICLE_TYPE_KEY[vehicle?.typeCar] ? t(VEHICLE_TYPE_KEY[vehicle.typeCar]) : vehicle?.name}<br />({vehicle?.efficiency} {t('km_per_liter')})
                                                </TableCell>
                                            )}

                                            {/* ชนิดน้ำมัน */}
                                            <TableCell sx={{ border: '1px solid rgba(0,0,0,0.2)' }}>
                                                {FUEL_NAME_KEY[fuelType?.fuelName] ? t(FUEL_NAME_KEY[fuelType.fuelName]) : fuelType?.fuelName}
                                            </TableCell>

                                            {/* ราคาต่อ ลิตร */}
                                            <TableCell sx={{ border: '1px solid rgba(0,0,0,0.2)' }}>
                                                {fuelType?.fuel?.price ? fuelType?.fuel?.price?.toFixed(2) : 'N/A'}
                                            </TableCell>

                                            {/* ปริมาณน้ำมันที่ใช้ */}
                                            <TableCell sx={{ border: '1px solid rgba(0,0,0,0.2)' }}>
                                                {oilUsageInMl.toFixed(2)} ml
                                            </TableCell>

                                            {/* ปริมาณคาร์บอน */}
                                            <TableCell sx={{ border: '1px solid rgba(0,0,0,0.2)' }}>
                                                {calculateCO2E(oilUsageInLiter).toFixed(2)} kg CO2e
                                            </TableCell>

                                            {/* ค่าใช้จ่าย */}
                                            <TableCell sx={{ border: '1px solid rgba(0,0,0,0.2)' }}>
                                                {calculatePriceBath(oilUsageInMl, fuelType?.fuel?.price).toFixed(2)}
                                            </TableCell>
                                        </TableRow>
                                    )
                                });
                            });
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* </Card> */}
        </Grid>
        // ... (ส่วนท้ายของ component เหมือนเดิม)
    );
};
export default TravelPlanner;